import React from 'react'
import ReactDOM from 'react-dom'

export default class DropoffTimetable extends React.Component {

  renderTime(start_at, end_at) {
    var closing = end_at == "-" ? I18n.t('shipbacks.modes.dropoffs.modal.closed') : end_at
    var opening = start_at == "-" ? I18n.t('shipbacks.modes.dropoffs.modal.closed') : start_at

    if (start_at == "-" && end_at == "-" ) {
      return (
        <span className="time">{I18n.t('shipbacks.modes.dropoffs.modal.closed')}</span>
      )
    } else {
      return (
        <span className="time">
          { opening + " / " + closing }
        </span>
      )
    }
  }

  renderTimetable(opening, index) {
    var days = I18n.t('date.day_names')
    var dayIndex = (index + 8) % 7
    return (
      <div key={index} className="col-6" id={days[dayIndex]}>
        <span className="day">{days[dayIndex]}</span>
        {this.renderTime(opening.start_at, opening.end_at)}
      </div>
    )
  }

  render() {
    if (this.props.timetable != undefined) {
      return (
        <div className="col-12">
          <div className="row timetable" id="select">
            <div className="col-12">
              <h4 className="opening">{I18n.t('shipbacks.modes.dropoffs.dropoff.opening_hours')}</h4>
            </div>
            { this.props.timetable.map((opening, index) => (
              this.renderTimetable(opening, index)
              ))
            }
          </div>
        </div>
      )
    } else {
      return (
        <div className="row spinner">
          <div className="col-12">
             <i className="fa-li fa fa-3x fa-spinner fa-spin"/>
            <h3>{I18n.t('shipbacks.modes.dropoffs.fetching.title')}</h3>
          </div>
        </div>
      )
    }
  }
}


// WEBPACK FOOTER //
// ./app/javascript/components/components/DropoffTimetable.jsx